import { Presence } from './Presence';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class User {
    constructor({ id, presence = new Presence({}), firstName = '', lastName = '', username = '', nickname = '', email = '', avatar = '', bio = '', data }) {
        this.id = void 0;
        this.presence = new Presence({});
        this.firstName = void 0;
        this.lastName = void 0;
        this.username = void 0;
        this.nickname = void 0;
        this.email = void 0;
        this.avatar = void 0;
        this.bio = void 0;
        this.data = void 0;
        this.id = id;
        this.presence = presence;
        this.firstName = firstName;
        this.lastName = lastName;
        this.username = username;
        this.nickname = nickname;
        this.email = email;
        this.avatar = avatar;
        this.bio = bio;
        this.data = data;
    }
}
